module.exports = __webpack_public_path__ + "img/contact-logo.b564c39d.png";